import { defineComponent as _defineComponent } from 'vue'
import OutstandingFeesBlock from 'ah-trades/src/components/fees/OutstandingFeesBlock.vue';
import { clientOutstandingFeesTableFields } from 'ah-trades/src/components/fees/tableFields/outstandingFeeTableFields';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'OutstandingFeesView',
  setup(__props) {

const tableConfig = computed(() => ({
  tableFields: clientOutstandingFeesTableFields,
}));

return { __sfc: true,tableConfig, OutstandingFeesBlock }
}

})